import { LinearProgress } from '@material-ui/core'
import i18n from 'i18next'
import { FC, Fragment } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { updateApartmentUserId } from '../../../../actions/apartments'
import { closeDialog } from '../../../../actions/dialogs'
import { CloseDialog } from '../../../../actions/types'
import {
  selectUsersAsArray,
  selectAreUsersLoading,
  selectUsers
} from '../../../../selectors/users'
import { UpdateApartmentUserIdProps as UpdateApartmentUserIdActionProps } from '../../../../types/apartments'
import { AutocompleteOption } from '../../../../types/autocomplete'
import { StateInterface, IndexedUsersState } from '../../../../types/states'
import { bindSubmitActionToPromise } from '../../../../utils/forms'
import { getUserAutocompleteOptions } from '../../../../utils/users'
import UpdateUserIdForm from './UpdateUserIdForm'

interface StateProps {
  loadingUsers: boolean
  indexedUsers: IndexedUsersState
  usersOptions: AutocompleteOption[]
}
const mapStateToProps = (state: StateInterface): StateProps => {
  const users = selectUsersAsArray(state)
  const usersOptions = getUserAutocompleteOptions(users)
  const indexedUsers = selectUsers(state)
  return {
    loadingUsers: selectAreUsersLoading(state),
    indexedUsers,
    usersOptions
  }
}

interface DispatchProps {
  closeDialogAction: CloseDialog
  updateApartmentUserIdAction: (props: UpdateApartmentUserIdActionProps) => void
}
const mapDispatchToProps = (dispatch: Dispatch) => ({
  closeDialogAction: (id: string) => dispatch(closeDialog(id)),
  updateApartmentUserIdAction: bindSubmitActionToPromise(
    dispatch,
    updateApartmentUserId
  )
})

interface OwnProps {
  t: i18n.TFunction
}

type UpdateApartmentUserIdProps = StateProps & DispatchProps & OwnProps

const UpdateApartmentUserId: FC<UpdateApartmentUserIdProps> = ({
  loadingUsers,
  updateApartmentUserIdAction,
  t,
  indexedUsers,
  closeDialogAction,
  usersOptions
}) => (
  <Fragment>
    {loadingUsers && <LinearProgress />}
    {!loadingUsers && (
      <UpdateUserIdForm
        updateApartmentUserId={updateApartmentUserIdAction}
        t={t}
        indexedUsers={indexedUsers}
        userOptions={usersOptions}
        closeDialog={closeDialogAction}
      />
    )}
  </Fragment>
)

export default connect<StateProps, DispatchProps, OwnProps, StateInterface>(
  mapStateToProps,
  mapDispatchToProps
)(UpdateApartmentUserId)
